import { useRoot } from "./useRoot";

/**
 * Obtains router instance
 */
export function useRouter() {
  const root = useRoot();
  return root.$router;
}
